module.exports = __webpack_public_path__ + "img/sharpen-left-violet.8bcd3d8e.png";